/**

 * Pokémon Singles – force grid visible (bypasses Dawn scroll-trigger + stale CSS cache)

 */

(function () {

  // #region agent log

  var DEBUG_ENDPOINT = 'http://127.0.0.1:7456/ingest/0fa77510-dc17-4c98-be5d-5004c5bcba28';

  var DEBUG_SESSION = '366844';



  function agentLog(hypothesisId, location, message, data) {

    try {

      fetch(DEBUG_ENDPOINT, {

        method: 'POST',

        headers: { 'Content-Type': 'application/json', 'X-Debug-Session-Id': DEBUG_SESSION },

        body: JSON.stringify({

          sessionId: DEBUG_SESSION,

          hypothesisId: hypothesisId,

          location: location,

          message: message,

          data: data || {},

          timestamp: Date.now(),

          runId: 'pre-fix',

        }),

      }).catch(function () {});

    } catch (e) {}

  }



  function diagnoseSinglesLayout(phase) {

    var path = window.location.pathname || '';

    if (path.indexOf('tcg-singles') === -1 && path.indexOf('pokemon-singles') === -1 && path.indexOf('/pages/singles') === -1) {

      return;

    }



    var grid = document.getElementById('product-grid');

    var container = document.getElementById('ProductGridContainer');

    var pageWidth = document.querySelector('.tcg-singles-page .page-width');

    var main = document.getElementById('MainContent');

    var gridStyle = grid ? window.getComputedStyle(grid) : null;

    var fab = document.querySelector('.tcg-card__cart-fab');

    var fabIcon = document.querySelector('.tcg-card__cart-fab-icon svg');

    var cardsCss = Array.prototype.slice.call(document.querySelectorAll('link[rel="stylesheet"]')).some(function (l) {

      return l.href && l.href.indexOf('tcg-collection-cards') !== -1;

    });



    agentLog('H1', 'tcg-singles-grid-fix.js:diagnose', 'grid computed layout ' + phase, {

      phase: phase,

      path: path,

      bodyClasses: document.body.className,

      productCount: grid ? grid.querySelectorAll('.grid__item').length : 0,

      gridDisplay: gridStyle ? gridStyle.display : null,

      gridTemplateColumns: gridStyle ? gridStyle.gridTemplateColumns : null,

      gridWidth: grid ? grid.getBoundingClientRect().width : null,

      viewportWidth: window.innerWidth,

      pageWidthEl: pageWidth ? pageWidth.getBoundingClientRect().width : null,

      mainWidth: main ? main.getBoundingClientRect().width : null,

    });



    agentLog('H3', 'tcg-singles-grid-fix.js:diagnose', 'width constraints ' + phase, {

      phase: phase,

      pageWidthMax: pageWidth ? window.getComputedStyle(pageWidth).maxWidth : null,

      mainPadding: main ? window.getComputedStyle(main).padding : null,

      tcgPageWidth: document.querySelector('.tcg-singles-page')

        ? document.querySelector('.tcg-singles-page').getBoundingClientRect().width

        : null,

    });



    agentLog('H2', 'tcg-singles-grid-fix.js:diagnose', 'stylesheet + fab ' + phase, {

      phase: phase,

      tcgCollectionCardsLinked: cardsCss,

      fabCount: document.querySelectorAll('.tcg-card__cart-fab').length,

      fabBg: fab ? window.getComputedStyle(fab).backgroundColor : null,

      fabColor: fab ? window.getComputedStyle(fab).color : null,

      fabIconDisplay: fabIcon ? window.getComputedStyle(fabIcon).display : null,

      fabIconFill: fabIcon ? window.getComputedStyle(fabIcon).fill : null,

    });



    var failedAssets = [];

    try {

      if (window.performance && performance.getEntriesByType) {

        performance.getEntriesByType('resource').forEach(function (entry) {

          if (

            entry.transferSize === 0 &&

            entry.decodedBodySize === 0 &&

            entry.duration > 0 &&

            /\.(js|css|svg|woff2?)(\?|$)/.test(entry.name)

          ) {

            failedAssets.push(entry.name.split('/').pop());

          }

        });

      }

    } catch (e) {}



    agentLog('H4', 'tcg-singles-grid-fix.js:diagnose', 'failed assets ' + phase, {

      phase: phase,

      failedAssets: failedAssets.slice(0, 12),

      quickAddDefined: typeof customElements !== 'undefined' && !!customElements.get('product-form'),

    });



    agentLog('H5', 'tcg-singles-grid-fix.js:diagnose', 'fixSinglesGrid state ' + phase, {

      phase: phase,

      hasContainer: !!container,

      hasTcgCards: container ? !!container.querySelector('.product-card-wrapper--tcg-single') : false,

      gridInlineDisplay: grid ? grid.style.display : null,

      gridItemCount: grid ? grid.children.length : 0,

    });

  }

  // #endregion



  function fixSinglesGrid() {

    var container = document.getElementById('ProductGridContainer');

    if (!container) return;



    var path = window.location.pathname || '';

    var isSingles =

      container.querySelector('.product-card-wrapper--tcg-single') ||

      document.body.classList.contains('template-tcg-singles') ||

      document.body.classList.contains('template-singles') ||

      document.body.classList.contains('template-pokemon-singles') ||

      path.indexOf('pokemon-singles') !== -1 ||

      path.indexOf('/pages/singles') !== -1 ||

      path.indexOf('/pages/tcg-singles') !== -1;



    if (!isSingles) return;



    [container].concat(Array.prototype.slice.call(container.querySelectorAll('.grid__item'))).forEach(function (el) {

      el.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');

      el.style.setProperty('opacity', '1', 'important');

      el.style.setProperty('transform', 'none', 'important');

    });



    var section = container.closest('.shopify-section');

    if (section) {

      var pad = section.querySelector('[class*="padding"]');

      if (pad) {

        pad.style.setProperty('background', 'rgb(15, 23, 42)', 'important');

        pad.style.setProperty('color', 'rgb(248, 250, 252)', 'important');

      }

    }



    var grid = document.getElementById('product-grid');

    if (grid && grid.tagName === 'UL') {

      grid.style.setProperty('display', 'grid', 'important');

    }

  }



  fixSinglesGrid();

  document.addEventListener('DOMContentLoaded', function () {

    fixSinglesGrid();

    diagnoseSinglesLayout('domcontentloaded');

  });

  window.addEventListener('load', function () {

    fixSinglesGrid();

    diagnoseSinglesLayout('load');

  });

  document.addEventListener('shopify:section:load', fixSinglesGrid);

})();


